//Swap labels to placeholders
function placeholderLabels() {
    var inputs = document.querySelectorAll(
        ".ContactFormWell .middleColumn input, .ContactFormWell .middleColumn textarea"
    );
    Array.prototype.forEach.call(inputs, function (input) {
        input.placeholder = input.labels.length
            ? input.labels[0].textContent.trim()
            : "";
    });
}

export default {
    init: function () {
        placeholderLabels();
    }
};
